import { ResponseType } from "../../../Types/ServicesType/servicesType"
import { MasterDataType, MasterTableDataType, SearchParamsType } from "./types"
import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import instance from "@services/services";
const { clinicId,createdById } = getConstants()
const {MastersApi} = api
export const getAllMasterData = async (params:SearchParamsType):Promise<ResponseType<{items:MasterTableDataType[],totalRecords:number}>>=>{
    const result = await instance.post(MastersApi.getAllInsurance,{...params,clinicId})
    return result.data
}

export const saveMasterData = async (params:{list:MasterDataType[]}):Promise<ResponseType<string>>=>{
    const result = await instance.post(MastersApi.saveInsuranceMaster,params)
    return result.data
}

export const uploadFile = async (file:File):Promise<ResponseType<string>>=>{
    const formData = new FormData();
    formData.append("clinicId", `${clinicId}`);
    formData.append("createdById", `${createdById}`);
    formData.append("file", file);
    const result = await instance.post(`${MastersApi.uploadInsuranceExcel}`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return result.data;
}